import React, { useContext, useEffect, useMemo, useState } from 'react';
import Onboarding from 'components/onboarding/Onboarding';
import { UserContext } from 'contexts/user/UserContext';
import RoutesProgressSaved from 'pages/Commons/Quest/RoutesProgressSaved';
import { useHistory, useLocation } from 'react-router-dom';
import DiscourseActivationPrompt from 'components/onboarding/DiscourseActivationPrompt';

/** This component is used in top level (App.js) and shows modals that should pop up in any route (onboarding, news, ...) */
const OverlayNotificationModal = (): React.ReactElement => {
  const { currentUser, isAuthenticated } = useContext(UserContext);
  const history = useHistory();

  // State variable to hold the sequence of modal names to be shown
  const [modalSequence, setModalSequence] = useState<string[]>([]);

  /* */
  /* Search Params */
  /* */
  const location = useLocation();
  const { search } = location;
  const searchParamsJoinClass = useMemo(() => { return new URLSearchParams(search).get('joinClass'); }, [search]);

  /* */
  /* Conditions */
  /* */
  // Check conditions and set the initial modal sequence when the component mounts
  useEffect(() => {
    const newModalSequence: string[] = [];
    const searchParamsJoinClass = new URLSearchParams(location?.search || '').get('joinClass');

    const quizProgressLocalStorage = JSON.parse(localStorage.getItem('quizProgress')) ?? [];
    const specimenObservedLocalStorage = JSON.parse(localStorage.getItem('specimenObserved')) ?? [];

    if (currentUser?.username && !currentUser?.name && !searchParamsJoinClass) {
      newModalSequence.push('Onboarding');
    }

    if ([...quizProgressLocalStorage, ...specimenObservedLocalStorage]?.length && isAuthenticated) {
      newModalSequence.push('RoutesProgressSaved');
    }

    setModalSequence(newModalSequence);
  }, [currentUser, isAuthenticated, searchParamsJoinClass, location?.search]);

  // Function to handle when a modal is closed
  // This is needed for modals that are triggered by local state that may change asynchronously.
  const handleModalClose = () => {
    setModalSequence((prevSequence) => prevSequence.slice(1));
  };

  const handleRoutesProgressSavedClose = (redirectPath?: string) => {
    handleModalClose();

    if (redirectPath) {
      history.replace(redirectPath);
    }
  };

  // Get the modal to be shown
  const currentModalName = modalSequence.length > 0 ? modalSequence[0] : '';

  /* */
  /* Render */
  /* */
  const renderModal = () => {

    switch (currentModalName) {
      case 'Onboarding':
        return <Onboarding userInfo={{ currentUser }} />;
      case 'RoutesProgressSaved':
        return <RoutesProgressSaved onClose={handleRoutesProgressSavedClose} />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {renderModal()}
      {!currentModalName && <DiscourseActivationPrompt />}
    </React.Fragment>
  );
};

export default OverlayNotificationModal;
